import React from "react";
import Carousel from "../careers/carousel/Carousel";

interface ITestimonial {
  id: number;
  name: string;
  description: string;
  position: string;
  image: string;
  linkedin: string;
  seeMore?: string;
}

interface TestimonialProps {
  title: string;
  smallDecription: string;
}

const SkillTestimonials: React.FC<TestimonialProps> = ({
  title,
  smallDecription,
}) => {
  const testimonials: ITestimonial[] = [
    {
      id: 1,
      name: "Akash",
      image: "/skill/testimonials/skill-testimonial-1.png",
      description:
        "I do admire the dedication and support provided by Dream Weavers Edutrack Pvt. Ltd., and I truly appreciate that. The DDU-GKY program has been a turning point in my life, helping me build confidence and essential skills. If you are determined to grow and achieve financial independence, Dream Weavers will guide you every step of the way.",
      position:
        "Trainee of Dream Weavers  Edutrack Pvt.Ltd under DDU-GKY Project.",
      linkedin: "linkedin.com/in/sarahchen",
      seeMore:
        "https://drive.google.com/file/d/10swdUo4GC7iZ4K94bXT4V37usP9_50RH/view?usp=sharing",
    },
    {
      id: 2,
      name: "Kishori Thakur",
      image: "/skill/testimonials/skill-testimonial-2.png",
      description:
        "I truly appreciate the guidance and support provided by Dream Weavers Edutrack Pvt. Ltd. The DDU-GKY program has played a crucial role in shaping my career and building my confidence. If you are eager to grow and achieve financial independence, Dream Weavers will help you turn your aspirations into reality.",
      position: "Retail Sales Associate Future Retail Limited",
      linkedin: "linkedin.com/in/mrodriguez",
      seeMore:
        "https://drive.google.com/file/d/1U9ufkGruDZoAUAHv4Jyrovz9Rcnd6Roh/view?usp=sharing",
    },
    {
      id: 3,
      name: "Payal Savner",
      image: "/skill/testimonials/skill-testimonial-3.png",
      description:
        "I truly admire the life-changing opportunities provided by Dream Weavers Edutrack Pvt. Ltd. The DDU-GKY program not only equipped me with essential skills but also gave me the confidence to overcome societal challenges. If you are determined to build a better future, Dream Weavers will empower you to turn your dreams into reality.",
      position: "Retail Sales Associate Reliance Mart, Indore",
      linkedin: "linkedin.com/in/priyapatel",
      seeMore:
        "https://drive.google.com/file/d/1NZGuhg7K4iQjpIOovcbTm5hSmn-fPTJo/view?usp=sharing",
    },
    {
      id: 4,
      name: "Priyanka Jambhekar",
      image: "/skill/testimonials/skill-testimonial-4.png",
      description:
        "I am deeply grateful to Dream Weavers Edutrack Pvt. Ltd. for providing me with the skills and confidence to build my career. The DDU-GKY program opened doors for me, helping me secure a stable job and achieve financial independence. If you have the determination to succeed, Dream Weavers will guide you toward a brighter future.",
      position: "Promoter, Koshar Infrastructure Pvt. Ltd.",
      linkedin: "linkedin.com/in/davidkim",
      seeMore:
        "https://drive.google.com/file/d/1CESxbbT6Y5FBs6cCRsEz-IG64fI8-ypJ/view?usp=sharing",
    },
    {
      id: 5,
      name: "Rajni Ahirwar",
      image: "/skill/testimonials/skill-testimonial-5.png",
      description:
        "I am truly grateful to Dream Weavers Edutrack Pvt. Ltd. and the DDU-GKY program for equipping me with the skills and confidence to step into the professional world. Today, I am working at Siyaram Enterprises, building a stable future for myself and my family. If you have the determination to grow, Dream Weavers will help you achieve your dreams.",
      position: "Assistant Warehouse, Siyaram Enterprises",
      linkedin: "linkedin.com/in/emmathompson",
      seeMore:
        "https://drive.google.com/file/d/1ujF1tKCT6-sUvXVzIKdbG0VCttGZYI19/view?usp=sharing",
    },
    {
      id: 6,
      name: "Rupali",
      image: "/skill/testimonials/skill-testimonial-6.png",
      description:
        "I am truly grateful to Dream Weavers Edutrack Pvt. Ltd. and the DDU-GKY program for providing me with the right skills and confidence to step into the professional world. If you have the determination to grow, this platform will always guide you towards success.",
      position: "Consultant, Veeba Food Services Pvt. Ltd.",
      linkedin: "linkedin.com/in/emmathompson",
      seeMore:
        "https://drive.google.com/file/d/1plaeeFfUSVXyLFVck5XtyLv6VuCyipvJ/view?usp=sharing",
    },
    {
      id: 7,
      name: "Kavita Akhileshwar",
      image: "/skill/testimonials/skill-testimonial-7.png",
      description:
        "Finding a way to support my children's education seemed impossible, but the livelihood mission gave me hope and direction. With determination and the right training, I secured a stable job and can now dream of a better future for my family. If you have the will, opportunities will follow.",
      position: "Employee,Siyaram Enterprises, Binoha, Haryana..",
      linkedin: "linkedin.com/in/emmathompson",
      seeMore:
        "https://drive.google.com/file/d/12r6G7EkJt1vZyFp3TSHT0n53dGtHM5n3/view?usp=sharing",
    },
    {
      id: 8,
      name: "Rajni",
      image: "/skill/testimonials/skill-testimonial-8.png",
      description:
        "Providing for my family felt like a distant dream, but the livelihood mission changed my path. With dedication and proper training, I secured a stable job and now envision a brighter future. Where there is determination, opportunities will always find a way.",
      position: "Counsellor, Fairdeal Services, Jalandhar, Punjab.",
      linkedin: "linkedin.com/in/emmathompson",
      seeMore:
        "https://drive.google.com/file/d/1vx_xulS4YLNCpBRhYQ_kjdOfm7Is2XBX/view?usp=sharing",
    },
  ];
  return (
    <div>
      <div className="w-full flex justify-center items-center">
        <div className="text-center max-w-6xl xl:pt-5">
          <h3 className="text-xl text-center font-light xl:text-6xl sm:text-2xl md:text-3xl lg:text-4xl">
            {title}
          </h3>
          <p className="text-neutral-600 pt-2 xl:pt-4 xl:text-[1.6rem] font-light">
            {smallDecription}
          </p>
        </div>
      </div>
      <div className="py-5 p-2 xl:px-20">
        <Carousel slides={testimonials} />
      </div>
    </div>
  );
};

export default SkillTestimonials;
